import type React from 'react'

import {
  BannerContainer,
  BannerContent,
  BannerIcon,
  BannerIconContainer,
  BannerText,
  BannerWrapper,
} from './styles'
import {
  type BannerProps,
  type BannerSize,
  BannerVariant,
  bannerSizes,
  type IconSize,
} from './types'

// Figma reference:
// https://www.figma.com/design/Dinixjb8Tcp92C1GVetpgZ/-%E2%AD%90%EF%B8%8FV1--Platform?node-id=1045-1907&t=G8aAgwkPX5YdSqjm-4
export const Banner = ({
  variant,
  message,
  rightContent,
  className,
  size = 'medium',
  iconSize,
}: BannerProps) => {
  // Handle empty/null message
  if (!message) {
    return null
  }

  const config = bannerSizes[size]
  const effectiveIconSize = iconSize ?? config.iconSize

  const content = (
    <BannerContainer variant={variant} className={className} size={size}>
      <BannerIconContainer>
        <BannerIcon variant={variant} size={effectiveIconSize} />
      </BannerIconContainer>
      <BannerContent>
        <BannerText variant={variant} size={size}>
          {message}
        </BannerText>
      </BannerContent>
      {rightContent}
    </BannerContainer>
  )

  return <BannerWrapper variant={variant}>{content}</BannerWrapper>
}

// Convenience exports for backward compatibility
export const ErrorBanner = ({
  message,
  rightContent,
  className,
  size,
  iconSize,
}: Omit<BannerProps, 'variant'>) => (
  <Banner
    variant={BannerVariant.Error}
    message={message}
    rightContent={rightContent}
    className={className}
    size={size}
    iconSize={iconSize}
  />
)

export const WarningBanner = ({
  text,
  rightContent,
  className,
  size,
  iconSize,
}: {
  text: string
  rightContent?: React.ReactNode
  className?: string
  size?: BannerSize
  iconSize?: IconSize
}) => (
  <Banner
    variant={BannerVariant.Warning}
    message={text}
    rightContent={rightContent}
    className={className}
    size={size}
    iconSize={iconSize}
  />
)
